import { Component } from '@verndale/core';

class CustomHeader extends Component {

  constructor(el: HTMLElement) {
    super(el);
    this.init();
  }

  init() {

    const sections = document.querySelectorAll("section");
    const navLi = document.querySelectorAll(".global-navigation__item a");

    window.addEventListener("scroll", () => {
      let current: string | null;
      sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      //console.log('height', sectionHeight);
      //console.log('top', sectionTop);
    

      if (scrollY >= sectionTop - sectionHeight / 3) {
        current = section.getAttribute("id");
      }
      //console.log('section', current);
      //console.log('calc', sectionTop - sectionHeight / 3);
      });

      navLi.forEach((links) => {
        links.classList.remove("active");
        if (links.contains(document.querySelector('.global-navigation__item a[href*=' + current + ']'))) {
          links.classList.add("active");
        }
        //console.log(navLi);
      });
    });
  }  
} 

export default CustomHeader;
